import JSBI from 'jsbi'

export const FACTORY_ADDRESS = '0x407C47E3FDB7952Ee53aa232B5f28566A024A759'

export const INIT_CODE_HASH = '0x9bbbc3a1671835a95223cff5fac60a303310de646cf33d8a420bcb4474601f33'

export const MINIMUM_LIQUIDITY = JSBI.BigInt(1000)

// exports for internal consumption
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const FIVE = JSBI.BigInt(5)
export const _997 = JSBI.BigInt(999)
export const _1000 = JSBI.BigInt(1000)
